var Events = {

  checkOrigin: function(event, expected) {
    if(!event) return false;
    
    // Ensure correct origin
    if (event.origin !== expected) {
      return false;
    }
    return true;
  },

  message: 'message',
  blur: 'blur',
  focus: 'focus',
  empty: 'empty',
  complete: 'complete',
  brand: 'brand',
  error: 'error',
  value: 'value',
  input: 'input',
  change: 'change',
};

module.exports = Events;


// WEBPACK FOOTER //
// ./app/events.js